module.exports = __webpack_public_path__ + "img/help.d2ae40f9.svg";